import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <path></path>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          strokeWidth="4"
          d=""
          fill="none"
          // fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M70 30 A20 20 0 1 0 50 50 A20 20 0 1 1 30 70"
      />
    </g>
  </svg>
);

export default IconLoader;
